module.exports = __webpack_public_path__ + "img/icon8.47ddbe0c.png";